module.exports = __webpack_public_path__ + "img/canvasMenuEdit.d1ce745b.svg";